import { useEffect } from "react";
import {
  clearNetworkErrorHandler,
  setNetworkErrorHandler,
} from "services/networkStatus";
import { startConnectivityMonitor } from "services/connectivityMonitor";
import ServerReconnecting from "./ServerReconnecting";

/**
 * Bridges network failures (detected by the axios response interceptor in
 * `services/api.js`) to the connectivity monitor and renders the app-wide
 * reconnecting overlay. Renders the overlay (nothing else) — mount it ONCE,
 * near the app root.
 *
 * - A genuine network failure (`ERR_NETWORK`, reported through
 *   `services/networkStatus`) starts the monitor, which pings the server
 *   every few seconds and decides whether the SERVER is down (X) or the
 *   DEVICE is offline (Y). It is idempotent, so a storm of parallel failures
 *   starts exactly one loop — no dedupe bookkeeping lives here anymore.
 * - `<ServerReconnecting />` renders nothing while everything is healthy and
 *   shows the full-screen overlay while a reconnect episode is in progress.
 *   Because it is fixed and app-wide, the page underneath (including any open
 *   form) stays mounted and unsaved work survives.
 */
const NetworkErrorListener = () => {
  useEffect(() => {
    setNetworkErrorHandler(() => startConnectivityMonitor());

    return () => {
      clearNetworkErrorHandler();
    };
  }, []);

  return <ServerReconnecting />;
};

export default NetworkErrorListener;
